import { logoSrc } from "@/lib/branding";

// Adaptive logo container: keeps ANY logo (light, dark, multicolor, transparent)
// visible by placing it on a neutral light surface with a subtle border + padding.
// Never recolors the customer's logo (object-contain, no filters).
export function BrandLogo({ business, size = 40, rounded = "rounded-xl", className = "" }) {
  const src = logoSrc(business);
  const dim = { width: size, height: size };
  if (src) {
    return (
      <div
        className={`shrink-0 bg-white border border-black/10 shadow-sm flex items-center justify-center overflow-hidden ${rounded} ${className}`}
        style={{ ...dim, padding: Math.max(2, Math.round(size * 0.12)) }}
        data-testid="brand-logo"
      >
        <img src={src} alt="Business logo" className="max-w-full max-h-full object-contain" />
      </div>
    );
  }
  return (
    <div
      className={`shrink-0 bg-emerald-500 text-white font-head font-extrabold flex items-center justify-center ${rounded} ${className}`}
      style={{ ...dim, fontSize: Math.round(size * 0.45) }}
      data-testid="brand-logo-fallback"
    >
      {(business?.name || "N")[0]}
    </div>
  );
}
